import { Title } from '@cambridgeassessment/cambridge-ui';
import styled from 'styled-components';

export const StyledTitle = styled(Title)`
  font-size: 22px;
  margin: 10px 0px 8px 0px;
`;

export const StyledSeriesTitle = styled(Title)`
  font-size: 22px;
  margin: 40px 0px 8px 0px;
`;

export const StyledExamTitle = styled(Title)`
  font-size: 22px;
  margin: 10px 0px -6px 0px;
`;
